<script setup>
    import { ref, watch } from "vue"
    import { useRoute } from 'vue-router'
    import { useAgencesStore } from '../stores/agences'    
    import {
        CalendarIcon,
        XMarkIcon,
        ChevronDownIcon,
        PhoneIcon,
        DevicePhoneMobileIcon,
        PrinterIcon,
        AtSymbolIcon,
        BuildingOffice2Icon,
        MapPinIcon,
        PencilIcon,
    } from '@heroicons/vue/24/outline'
    import { Menu, MenuButton, MenuItem, MenuItems, TransitionRoot, TransitionChild, Dialog, DialogTitle, DialogPanel } from '@headlessui/vue'
    import { useUserStore } from "../stores/user"
    import { ArrowRightIcon } from "@heroicons/vue/24/solid"

    const agencesStore = useAgencesStore();
    const userStore = useUserStore();
    const route = useRoute();
    const openPopupUpdateAgence = ref(false);
    
    const agence = ref(null)
    const erreur = ref('');
    const inCreation = ref(false);
    const successCreation = ref(false);
    const errorCreation = ref(false);

    const openTestPopup = ref(false);

    const agent_to_add = ref(null);
    const agents = ref(null);

    const sending = ref(false);

    const users = ref([
        {
            name: 'Responsable',
            agents: []
        },
        {
            name: 'Conseillers',
            agents: [],
        }
    ]);

    const agentInfo = ref({});
    const updateAgent = (agent) => {
        agentInfo.value = agent;
        openPopupUpdateAgence.value = true;

        console.log(agentInfo.value)
    }

    const deleteAgent = (agent) => {
        if(confirm('Êtes-vous sur de vouleur supprimer ce conseiller ?')){
            userStore.deleteUser(agent.ID)
            .then(res => {
                fetchConseiller();
            })
            .catch(err => {
                console.error(err)
            });
        }
    }

    const fetchConseiller = () => {
        agencesStore.getAgence(route.params.id)
        .then(res => {
            agence.value = res.agence;
            users.value[0].agents = [res.responsable];
            users.value[1].agents = res.conseillers;
        })
        .catch(err => {
            console.error(err);
        }) 
    }

    const fetchAllConseiller = () => {
        userStore.getAllUser()
        .then(res => {
            agents.value = res.users;
        })
    }
    fetchAllConseiller();

    const addUserToAgent = () => {
        sending.value = true;
        agencesStore.addUserToAgence(agence.value.id_agence, agent_to_add.value)
        .then(res =>{
            fetchConseiller();
            sending.value = false;
            setTimeout(() => {
                openTestPopup.value = false;
                
            }, 1500)
        })
        .catch(err => {
            if(err.response?.data?.message){
                erreur.value = err.response.data.message;
            } else {
                erreur.value = err.message
            }
            sending.value = false;

            setTimeout(() => {
                erreur.value = '';
            }, 1500)
        })
    }

    const removeUserFromAgence = (agent) => {
        if(window.confirm('Êtes-vous sur de vouloir retirer cet agent de l\'agence')){
            agencesStore.removeUserFromAgence(agence.value.id_agence, agent.ID)
            .then(res => {
                fetchConseiller();
            })
        }
    }

    const handleUpdateAgence = async (e) => {
        let formdata = new FormData(e.target);
        successCreation.value = false;
        errorCreation.value = false;
        inCreation.value = true;
        try {
            const agence = await agencesStore.updateAgence(formdata);
            successCreation.value = true;
            setTimeout(() => {
                openPopupUpdateAgence.value = false;
            }, 1500)
        
        } catch (error) {
            errorCreation.value = true;
        } finally {
            inCreation.value = false;
        }
    }

    watch(() => route.params.id, fetchConseiller, {immediate: true});
</script>

<template>
    <div class="sm:h-screen border-r border-r-gray-100 flex-1 sm:overflow-y-auto overflow-x-auto sm:pb-24">
        <div class="sm:px-8 px-5 py-10 w-full" v-if="agence">
            <div class="lg:flex lg:items-center lg:justify-between">
                <div class="min-w-0 flex-1">
                    <div class="flex items-center gap-x-3 mt-2">
                        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                            {{ agence.lib_agence}}
                        </h2>
                        <button 
                            v-if="userStore.userLog.adm_util == 1" @click="() => { openPopupUpdateAgence = true; }" 
                            type="button" 
                            class="block rounded-md bg-rose px-3 py-1.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-rose-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600">
                            Modifier les informations
                        </button>
                    </div>
                
                    <div class="mt-2 flex flex-col sm:mt-2 sm:flex-row sm:flex-wrap sm:gap-x-6 gap-y-1">
                        <div class="flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:gap-x-6 gap-y-3"> 
                            <div v-if="agence.adr_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <MapPinIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                {{ agence.adr_agence }}
                            </div>
                            <div v-if="agence.hor_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <CalendarIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                {{ agence.hor_agence }}
                            </div>
                        </div>
                        
                        <div class="flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:gap-x-6 gap-y-3">
                            <div v-if="agence.mail_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <AtSymbolIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                <a class="hover:text-rose" :href="`mailto:${agence.mail_agence}`">{{ agence.mail_agence }}</a>
                            </div>
    
                            <div v-if="agence.tel_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <PhoneIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                <a class="hover:text-rose" :href="`tel:${agence.tel_agence}`">{{ agence.tel_agence }}</a>
                            </div>
    
                            <div v-if="agence.port_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <DevicePhoneMobileIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                <a class="hover:text-rose" :href="`tel:${agence.port_agence}`">{{ agence.port_agence }}</a>
                            </div>
    
                            <div v-if="agence.fax_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <PrinterIcon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                <a class="hover:text-rose" :href="`fax:${agence.fax_agence}`">{{ agence.fax_agence }}</a>
                            </div>
    
                            <div v-if="agence.siren_agence" class="mt-2 flex items-center text-sm text-gray-500">
                                <BuildingOffice2Icon class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" aria-hidden="true" />
                                SIRET {{ agence.siren_agence }}
                            </div>
                        </div>
                    </div>  
                </div>
            </div>
        </div> 

        <div class="px-4 sm:px-6 lg:px-8 mt-12" v-if="users">
            <div class="sm:flex sm:items-center">
                <div class="sm:flex-auto">
                    <h1 class="text-base font-semibold leading-6 text-gray-900">Utilisateurs</h1>
                    <p class="mt-2 text-sm text-gray-700">Liste des comptes associés à l'agence.</p>
                </div>
                <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none flex items-center gap-x-2">
                    <button 
                        v-if="userStore.userLog.adm_util == 1" @click="() => { openTestPopup = true; }" 
                        type="button" 
                        class="block rounded-md bg-rose px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-rose-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-rose-600">
                        Ajouter un conseiller
                    </button>
                </div>
            </div>
            <div class="mt-8 flow-root">
                <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                    <table class="min-w-full">
                        <thead class="bg-white">
                            <tr>
                                <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3">ID</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Nom</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Prenom</th>
                                <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Rôle</th>
                                <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-3">
                                    <span class="sr-only">Edit</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody class="bg-white">
                            <template v-for="user in users" :key="user.name">
                                <tr class="border-t border-gray-200">
                                    <th colspan="5" scope="colgroup" class="bg-gray-50 py-2 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-3">{{ user.name }}</th>
                                </tr>
                                <tr v-for="(agent, personIdx) in user.agents" :class="[personIdx === 0 ? 'border-gray-300' : 'border-gray-200', 'border-t']">
                                    <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">{{ agent.ID }}</td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ agent.nom }}</td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ agent.prenom }}</td>
                                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ agent.role }}</td>
                                    <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
                                        <a v-if="userStore.userLog.adm_util == 1" @click="removeUserFromAgence(agent)" href="#" class="text-rose hover:text-rose-400">Retirer de l'agence</a>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- #region POPUP Update Agence -->
	<TransitionRoot :show="openPopupUpdateAgence" as="template" appear>
		<Dialog as="div" class="relative z-50" @close="openPopupUpdateAgence = false">
			<TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
				<div class="fixed inset-0 bg-black backdrop-blur-sm bg-opacity-50 transition-opacity" />
			</TransitionChild>

			<div class="fixed inset-0 z-10 w-screen overflow-y-auto p-4 sm:p-6 md:p-20">
				<TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="ease-in duration-200" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
					<DialogPanel class="mx-auto max-w-xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all">
						<div class="px-12 py-8">
                            <form method="POST" @submit.prevent="handleUpdateAgence">
                                <div class="mx-auto max-w-2xl text-center">
                                    <h2 class="text-2xl font-bold tracking-tight text-rose">Informations de l'agence</h2>
                                </div>
                                
                                <input type="hidden" name="id_agence" :value="route.params.id">
                                
                                <div class="pb-12 mt-6">
                                    <div class="mt-10 grid grid-cols-1 gap-x-3 gap-y-4 sm:grid-cols-6">
                                        <div class="sm:col-span-full">
                                            <label for="jur_agence" class="block text-sm/6 font-medium text-gray-900">Nom juridique</label>
                                            <div class="mt-2">
                                                <input v-model="agence.jur_agence" type="text" name="jur_agence" id="jur_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-full">
                                            <label for="lib_agence" class="block text-sm/6 font-medium text-gray-900">Nom de l'agence</label>
                                            <div class="mt-2">
                                                <input v-model="agence.lib_agence" type="text" name="lib_agence" id="lib_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-full">
                                            <label for="adr_agence" class="block text-sm/6 font-medium text-gray-900">Adresse</label>
                                            <div class="mt-2">
                                                <input v-model="agence.adr_agence" type="text" name="adr_agence" id="adr_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>


                                        <div class="sm:col-span-3">
                                            <label for="ville_agence" class="block text-sm/6 font-medium text-gray-900">Ville</label>
                                            <div class="mt-2">
                                                <input v-model="agence.ville_agence" type="text" name="ville_agence" id="ville_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <label for="cp_agence" class="block text-sm/6 font-medium text-gray-900">Code postal</label>
                                            <div class="mt-2">
                                                <input v-model="agence.cp_agence" type="text" name="cp_agence" id="cp_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <label for="tel_agence" class="block text-sm/6 font-medium text-gray-900">Téléphone fixe</label>
                                            <div class="mt-2">
                                                <input v-model="agence.tel_agence" type="text" name="tel_agence" id="tel_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-3">
                                            <label for="port_agence" class="block text-sm/6 font-medium text-gray-900">Téléphone portable</label>
                                            <div class="mt-2">
                                                <input v-model="agence.port_agence" type="text" name="port_agence" id="port_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>


                                        <div class="sm:col-span-full">
                                            <label for="mail_agence" class="block text-sm/6 font-medium text-gray-900">E-mail de l'agence</label>
                                            <div class="mt-2">
                                                <input v-model="agence.mail_agence" type="email" name="mail_agence" id="mail_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-full"> 
                                            <label for="siren_agence" class="block text-sm/6 font-medium text-gray-900">SIRET</label>
                                            <div class="mt-2">
                                                <input v-model="agence.siren_agence" type="text" name="siren_agence" id="siren_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-full"> 
                                            <label for="tva_agence" class="block text-sm/6 font-medium text-gray-900">TVA</label>
                                            <div class="mt-2">
                                                <input v-model="agence.tva_agence" type="text" name="tva_agence" id="tva_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-full"> 
                                            <label for="naf_agence" class="block text-sm/6 font-medium text-gray-900">NAF</label>
                                            <div class="mt-2">
                                                <input v-model="agence.naf_agence" type="text" name="naf_agence" id="naf_agence" class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 ring-1 ring-inset ring-gray-300  placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
                                            </div>
                                        </div>

                                        <div class="sm:col-span-full"> 
                                            <label for="hor_agence" class="block text-sm font-medium leading-6 text-gray-900">Horaires</label>
                                            <div class="mt-2">
                                                <textarea id="hor_agence" name="hor_agence" v-model="agence.hor_agence" rows="3" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-rose-600 sm:text-sm sm:leading-6" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="flex justify-end gap-x-3">
                                    <button @click="openPopupUpdateAgence = false" type="button"
                                        class="inline-flex gap-2 items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                                        Annuler
                                    </button>
                                    <button type="submit"
                                        class="inline-flex gap-2 items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" 
                                        :class="inCreation ? 'pointer-events-none opacity-30' : ''">
                                        Valider
                                        <svg v-if="inCreation" class="animate-spin ml-1 h-3 w-3 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                        </svg>
                                    </button>
                                </div>   

                                <span class="block text-center text-green-500 mt-2" v-if="successCreation">
                                    L'agence a été modifié avec succès
                                </span>

                                <span class="block text-center text-red-500 mt-2" v-if="errorCreation">
                                    Une erreur est survenue.
                                </span>
                            </form>
						</div>
					</DialogPanel>
				</TransitionChild>
			</div>
		</Dialog>
	</TransitionRoot>
    <!-- #endregion -->

    <!-- #region POPUP ajout Conseiller -->
	<TransitionRoot :show="openTestPopup" as="template" appear>
		<Dialog as="div" class="relative z-50" @close="openTestPopup = false">
			<TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
				<div class="fixed inset-0 bg-black backdrop-blur-sm bg-opacity-50 transition-opacity" />
			</TransitionChild>

			<div class="fixed inset-0 z-10 w-screen overflow-y-auto p-4 sm:p-6 md:p-20">
				<TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 scale-95" enter-to="opacity-100 scale-100" leave="ease-in duration-200" leave-from="opacity-100 scale-100" leave-to="opacity-0 scale-95">
					<DialogPanel class="mx-auto max-w-xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black ring-opacity-5 transition-all">
						<div class="px-12 py-8">
							<div class="mx-auto max-w-2xl text-center">
								<h2 class="text-4xl font-bold tracking-tight text-rose">Ajouter un conseiller</h2>
								<p class="mt-6 text-sm leading-6">Sélectionner un agent pour l'associé à l'agence.</p>
							</div>

							<div class="mt-4">
								<label for="agent_to_add" class="block text-sm leading-6 text-gray-800">Agent</label>
								<select v-model="agent_to_add" id="agent_to_add" name="agent_to_add" class="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6">
                                    <option value="none" selected>Sélectionner un agent</option>
									<option v-for="agent in agents" :key="agent.id_util" :value="agent.id_util">{{ agent.pNoms_util }} {{ agent.nom_util }}</option>
								</select>
							</div>

							<div class="mt-5 flex items-center justify-center gap-x-2">
								<a @click="openTestPopup = false; openTestPopup = false;" class="inline-flex gap-2 items-center justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">Annuler</a>
								<a @click="addUserToAgent" :class="sending ? 'active opacity-75 pointer-events-none' : false" class="group inline-flex gap-2 items-center justify-center rounded-md bg-rose px-3 py-2 text-sm font-semibold text-white shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-rose-600">
									Ajouter 
									<span class="group-[.active]:hidden" aria-hidden="true">
										<ArrowRightIcon class="ml-1 h-3 w-3 text-white"/>
									</span>
									<span class="group-[.active]:block hidden" aria-hidden="true">
										<svg class="animate-spin ml-1 h-3 w-3 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
											<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
											<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
										</svg>
									</span>
								</a>
							</div> 

                            <p v-if="erreur" class="text-center text-xs mt-6 text-red-400">Impossible d'ajouter l'agent - {{ erreur }}</p>
						</div>
					</DialogPanel>
				</TransitionChild>
			</div>
		</Dialog>
	</TransitionRoot>
    <!-- #endregion -->
</template>
